// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database'; // Import the getDatabase function
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from 'firebase/auth';
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAbJG9ncx--2lRyGZwdcEWt8IL00p3m1bw',
  authDomain: 'genius-office.firebaseapp.com',
  projectId: 'genius-office',
  storageBucket: 'genius-office.appspot.com',
  messagingSenderId: '378785498497',
  appId: '1:378785498497:web:ebfe6c1115c0b081b71480',
  measurementId: 'G-DJBSL9DK35',
};
// deleteWholeDatabase('firebaseLocalStorageDb');
// deleteWholeDatabase('firebase-heartbeat-database');

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const email = 'routebilling@geniusoffice.com';
const password = '123123';
const firebaseAuthRecoveryKey = 'firebase-auth-recovery-attempted';
let firebaseSignInPromise;

const clearFirebaseAuthRecoveryFlag = () => {
  try {
    sessionStorage.removeItem(firebaseAuthRecoveryKey);
  } catch (error) {
    console.error('Unable to clear Firebase recovery flag', error);
  }
};

const markFirebaseAuthRecoveryAttempt = () => {
  try {
    if (sessionStorage.getItem(firebaseAuthRecoveryKey)) {
      return false;
    }

    sessionStorage.setItem(firebaseAuthRecoveryKey, 'true');
    return true;
  } catch (error) {
    console.error('Unable to save Firebase recovery flag', error);
    return false;
  }
};

export const clearFirebaseAuthPersistence = () =>
  new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error('IndexedDB is not available'));
      return;
    }

    const request = indexedDB.open('firebaseLocalStorageDb');

    request.onsuccess = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains('firebaseLocalStorage')) {
        db.close();
        resolve();
        return;
      }

      const transaction = db.transaction('firebaseLocalStorage', 'readwrite');
      transaction.objectStore('firebaseLocalStorage').clear();

      transaction.oncomplete = () => {
        db.close();
        resolve();
      };
      transaction.onerror = () => {
        db.close();
        reject(transaction.error);
      };
      transaction.onabort = () => {
        db.close();
        reject(transaction.error);
      };
    };

    request.onerror = () => reject(request.error);
  });

export const signInToFirebase = async () => {
  if (auth.currentUser) {
    clearFirebaseAuthRecoveryFlag();
    return auth.currentUser;
  }

  if (!firebaseSignInPromise) {
    firebaseSignInPromise = signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        clearFirebaseAuthRecoveryFlag();
        return userCredential.user;
      })
      .finally(() => {
        firebaseSignInPromise = null;
      });
  }

  return firebaseSignInPromise;
};

export const ensureFirebaseAuthWithRecovery = async () => {
  try {
    return await signInToFirebase();
  } catch (loginError) {
    if (!markFirebaseAuthRecoveryAttempt()) {
      throw loginError;
    }

    try {
      await clearFirebaseAuthPersistence();
      window.location.reload();
      return null;
    } catch (recoveryError) {
      clearFirebaseAuthRecoveryFlag();
      throw recoveryError;
    }
  }
};

signInToFirebase()
  .then(() => {
    console.log('sign in signInWithEmailAndPassword');
  })
  .catch((error) => {
    console.error('Firebase login failed', error);
  });

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/auth.user
    console.log('signin');
    // ...
  } else {
    // User is signed out
    // ...
    console.log('signout');
  }
});

const database = getDatabase(app);

export default database;
